var React = require('react');

function DifficultyLevelBlack2WhiteOutline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.639721 7.81196L6.23397 0.801652L11.8273 7.81196L6.23397 14.8205L0.639721 7.81196Z","fill":"black","stroke":"white","key":0}),React.createElement("path",{"d":"M9.6397 7.81198L15.234 0.801652L20.8273 7.81198L15.234 14.8214L9.6397 7.81198Z","fill":"black","stroke":"white","key":1})]);
}

DifficultyLevelBlack2WhiteOutline.defaultProps = {"viewBox":"0 0 22 16","fill":"none"};

module.exports = DifficultyLevelBlack2WhiteOutline;

DifficultyLevelBlack2WhiteOutline.default = DifficultyLevelBlack2WhiteOutline;
